import { Option } from 'types/Option';
import { sortCodes } from 'utils/sortingMethods';

const optionData = (code: string, t: (key: string) => string) => {
  if (!code) return undefined;

  return {
    value: code,
    label: t(`languages.${code}`)
  };
};

export const availableLanguageOptions = (
  all: string[] | undefined,
  excluded: string[],
  mostUsed: string[],
  current: string | undefined,
  t: (key: any) => string,
  locale: string
) => {
  const languagesToExclude = excluded.filter((code) => code != current);

  const mostUsedOptions = (mostUsed
    ?.filter((code) => !languagesToExclude.includes(code))
    ?.sort(sortCodes(t, locale))
    ?.map((code) => optionData(code, t))
    ?.filter(Boolean) ?? []) as Option[];

  const leastUsedOptions = (all
    ?.filter((code) => !mostUsed.includes(code) && !languagesToExclude.includes(code))
    ?.sort(sortCodes(t, locale))
    ?.map((code) => optionData(code, t))
    ?.filter(Boolean) ?? []) as Option[];

  if (!mostUsedOptions.length) return leastUsedOptions;

  return [
    ...mostUsedOptions,
    ...(mostUsedOptions.length > 0 && leastUsedOptions.length > 0
      ? [{ value: '--', label: '----------------', disabled: true }]
      : []),
    ...leastUsedOptions
  ];
};
